import useTranslation from 'next-translate/useTranslation';
import OptionsControl from 'src/themes/cosmos/components/OptionsControl';
import { SUBTITLE_COLOR_OPTIONS } from 'src/interfaces/enums';
import useSubtitle from 'src/hooks/useSubtitle';
import { ISubtitleStyle } from 'src/interfaces/Subtitle';
import { useMemo } from 'react';

const SubtitleColorsControl = () => {
  const { t } = useTranslation('common');
  const { subtitleStyle, saveUpdatedSubtitleStyle } = useSubtitle();

  const colorOptions = useMemo(() => {
    return Object.values(SUBTITLE_COLOR_OPTIONS).map((color) => ({
      label: t(`subtitles.styles.colors.${color}`),
      value: color,
    }));
  }, [t]);

  return (
    <OptionsControl
      selectedOptionValue={subtitleStyle.color}
      onChange={(color) => {
        saveUpdatedSubtitleStyle({ color } as Partial<ISubtitleStyle>);
      }}
      options={colorOptions}
    />
  );
};

export default SubtitleColorsControl;
